import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import resume from '../../../assets/resume/ResumeOfNajmulHaque.pdf'

const Navbar = () => {

    const menuItem = <>

        <li><HashLink to="/">Home</HashLink></li>
        <li><HashLink to="/home#about">About</HashLink></li>
        <li><HashLink to="/home#projects">Projects</HashLink></li>
        <li><HashLink to="/blogs">Blogs</HashLink></li>
        <li><HashLink to="/home#contact">Contact</HashLink></li>
        <a className="btn btn-outline btn-primary text-white ml-3" href={resume} download role='button'>Download Resume</a>

    </>

    return (
        <div className="navbar sticky top-0 z-10 bg-secondary ">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex="0" className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex="0" className="menu menu-compact dropdown-content text-black mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        {menuItem}
                    </ul>
                </div>
                <Link to='/' className="btn btn-ghost normal-case text-xl text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">Najmul</Link>
            </div>
            <div className="navbar-end hidden lg:flex text-white">
                <ul className="menu menu-horizontal p-0">
                    {menuItem}
                </ul>
            </div>
        </div>
    );
};

export default Navbar;